if (!customElements.get('results-desktop-sort')) {
  customElements.define(
    'results-desktop-sort',
    class ResultsDesktopSort extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.eventBus = window.theme.results.eventBus
      }

      connectedCallback () {
        super.connectedCallback()

        this.elements = {
          menu: this.querySelector('[data-results-desktop-sort-el="menu"]'),
        }

        this.renderSortOptions(window.theme.results.stateLayer.state.sort)

        this.onActiveSortUpdated = () => {
          this.renderSortOptions(window.theme.results.stateLayer.state.sort)
        }

        this.eventBus.subscribe(
          window.theme.results.events.STATE.ACTIVE_SORT_UPDATED,
          this.onActiveSortUpdated,
        )
      }

      disconnectedCallback () {
        this.eventBus.unsubscribe(
          window.theme.results.events.STATE.ACTIVE_SORT_UPDATED,
          this.onActiveSortUpdated,
        )
      }

      setupEventListeners () {
        this.elements.menu
          .querySelectorAll('.clc-Sort_Facet')
          .forEach(button => {
            button.addEventListener('click', this.handleSortChange.bind(this))
          })
      }

      handleSortChange (event) {
        const value = event.currentTarget.getAttribute('data-sort-value')
        const [field, order] = value.split('~')

        this.eventBus.publish(window.theme.results.events.UI.SORT_CHANGED, {
          field,
          order,
        })
      }

      renderSortOptions (sortOptions) {
        this.elements.menu.innerHTML = ''
        sortOptions.forEach(sortOption => {
          this.elements.menu.insertAdjacentHTML(
            'beforeend',
            this.listItemTemplate(sortOption),
          )
        })
        this.setupEventListeners()
      }

      listItemTemplate (sortOption) {
        return `
          <li role="presentation">
            <button role="menuitem" data-sort-value="${sortOption.field}~${
          sortOption.order
        }" class="clc-Sort_Facet" aria-pressed="${
          sortOption.selected ? 'true' : 'false'
        }">
              ${sortOption.label}
            </button>
          </li>
        `
      }
    },
  )
}
